<div [ngClass]="wrapperClass">
    <button
        *ngFor="let option of options; trackBy: trackByValue"
        type="button"
        class="font-semibold transition hover:bg-white/70 disabled:cursor-not-allowed disabled:opacity-60"
        [ngClass]="[
            buttonClass,
            layout === 'wrap'
                ? (isSelected(option) ? 'border-sky-200 bg-sky-50 text-sky-700' : 'border-white/60 bg-white/55 text-slate-600')
                : (isSelected(option) ? 'bg-white text-slate-950 shadow-sm' : 'text-slate-600')
        ]"
        [disabled]="isDisabled(option)"
        [attr.aria-pressed]="isSelected(option)"
        (click)="select(option)">
        {{ translateLabels ? (option.label | translate) : option.label }}
    </button>
</div>
